import { Component, Vue } from 'vue-property-decorator';
import { getComponentProps } from '@/utils/vueUtils';
import VimeoVideoPlayer from '@/components/VimeoVideoPlayer/VimeoVideoPlayer.vue';
import ResponsiveImage from '@/components/ResponsiveImage/ResponsiveImage.vue';
import Cutout from '@/components/CutoutComponent/CutoutComponent.vue';
import VideoPlayerViewModel from './VideoPlayerModule.types';
import { VideoJsPlayerOptions } from 'video.js';
import { ImageSizes, ImageSize } from '@/common/interfaces/SizeBreakpoints';

import { getResizeImage } from '@/utils/commonUtils';

const VideoPlayerModuleProps = Vue.extend({
  props: getComponentProps<VideoPlayerViewModel>({
    Title: 'Discovery Alaska',
    BackgroundTitle: 'Discover',
    BackgroundImage: { Url: getResizeImage('snow-hike.jpg'), Alt: '' },
    Video: {
      Url:
        'https://player.vimeo.com/external/378567776.hd.mp4?s=a1da3193ace2f94a917e55cd0001722704d1ea1e&profile_id=175',
      Type: 'video/mp4',
      Poster: getResizeImage('moose.jpg'),
    },
    VideoCaption: '',
    HeaderTag: 'h3',
  }),
});

@Component({
  components: {
    ResponsiveImage,
    VimeoVideoPlayer,
    Cutout,
  },
})
export default class VideoPlayerModule extends VideoPlayerModuleProps {
  videoIsActive = false;

  options = {
    autoplay: false,
    loop: false,
    muted: false,
    controls: true,
    playsinline: true,
  } as VideoJsPlayerOptions;

  handleVideoActive(isActive: boolean) {
    this.videoIsActive = isActive;
  }

  imageSizes: ImageSizes = {
    def: new ImageSize([559, 250]),
    sizes: {
      sm: new ImageSize([767, 250]),
      md: new ImageSize([991, 512]),
      lg: new ImageSize([1199, 512]),
      xl: new ImageSize([1500, 910]),
    },
  };

  cutoutSizes1: ImageSizes = {
    def: new ImageSize([111, 111]),
    sizes: {
      md: new ImageSize([178, 178]),
    },
  };

  cutoutSizes3: ImageSizes = {
    def: new ImageSize([64, 64]),
    sizes: {
      md: new ImageSize([89, 89]),
      xl: new ImageSize([140, 140]),
    },
  };
}
